import { render, staticRenderFns } from "./EmailOutlineIcon.vue?vue&type=template&id=7856d2ae"
import script from "./EmailOutlineIcon.vue?vue&type=script&lang=ts"
export * from "./EmailOutlineIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports